import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("aud.config.form_images.generative_image_title"))),
      ]),
      _vm._t("default"),
      _vm._t("default"),
      _c(VBreadcrumbs, { staticClass: "pa-0 py-2 text--black" }, [
        _vm._v(" Mis imagenes generadas por Chat GPT "),
      ]),
      _c("image-generator-component", {
        attrs: {
          info: _vm.info,
          is_audience: _vm.is_audience,
          list_to_paginate: _vm.list_to_paginate,
          image: _vm.image,
          list_images: _vm.list_images,
          list_images_new: _vm.list_images_new,
        },
        on: { "child-clicked": _vm.nexChildtImages },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }